const initState = { authError: null };

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_ERROR":
      console.log("Login Error");
      return { ...state, authError: "Login Failed" };
    case "LOGIN_SUCCESS":
      console.log("Login Success");
      return {
        ...state,
        authError: null
      };
    case "SIGNOUT_SUCCESS":
      console.log("Signout success");
      return state;
    case "SIGNUP_SUCCESS":
      console.log("SignUp success");
      return {
        ...state,
        authError: null
      };
    case "SIGNUP_ERROR":
      console.log("SignUp error: ", action.err.message);
      return {
        ...state,
        authError: action.err.message
      };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js